import * as React from 'react'
import { Group, Panel, Separator } from 'react-resizable-panels'
import { cn } from '@/lib/utils'

/**
 * Figma (node 17382:7210 — Resizable):
 *
 * Container: bg-background, border border-border, rounded-lg (10px), flex
 * Panel: flex-1, overflow-clip
 * Handle (node 18449:209):
 *   Inner bar: w-1 (4px), h-6 (24px), bg-border, rounded-lg (10px), centered
 *   Focus: ring-1 ring-ring
 *
 * Note: react-resizable-panels v4 uses `orientation` prop (not `direction`).
 * The library handles flex-direction via inline styles.
 */

const IntuiResizablePanelGroup = ({
  className,
  ...props
}: React.ComponentProps<typeof Group>) => (
  <Group
    className={cn('flex h-full w-full rounded-lg border bg-background', className)}
    {...props}
  />
)
IntuiResizablePanelGroup.displayName = 'IntuiResizablePanelGroup'

const IntuiResizablePanel = ({
  className,
  ...props
}: React.ComponentProps<typeof Panel>) => (
  <Panel
    className={cn('overflow-clip', className)}
    {...props}
  />
)
IntuiResizablePanel.displayName = 'IntuiResizablePanel'

const IntuiResizableHandle = ({
  className,
  ...props
}: React.ComponentProps<typeof Separator>) => (
  <Separator
    className={cn(
      'relative flex items-center justify-center bg-border',
      'focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-offset-1',
      className,
    )}
    {...props}
  >
    <div className="z-10 w-1 h-6 rounded-lg bg-border" />
  </Separator>
)
IntuiResizableHandle.displayName = 'IntuiResizableHandle'

export {
  IntuiResizablePanelGroup,
  IntuiResizablePanel,
  IntuiResizableHandle,
}
